module.exports = __webpack_public_path__ + "static/Ranger 4-d15f54331730a6bbc55b0163595eed5a.jpg";